/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { Suspense } from "react";

import { BUIProvider } from "@bookingcom/bui-react";
import travellerTheme from "@bookingcom/bui-react/themes/traveller_ex";
import ErrorReporter from "@bookingcom/react-error-reporter";
import { FlightsErrorReporter } from "../utils/report-error";

import AriaLive from "../components/elements/AriaLive";
import GenericErrorReport from "../components/elements/GenericErrorReport";
import Trackers from "../components/elements/Trackers";

import useGlobalContext from "../hooks/useGlobalContext";
import useRouteChangeTracking from "../hooks/useRouteChangeTracking";
import usePageviewIsNotABounce from "../hooks/usePageviewIsNotABounce";
import useUserAgent from "../hooks/useUserAgent";

import { setMarketingTrackingVariables } from "../utils/marketing-url-params";
import Layout from "./Layout";
import useC360Tracker from "../hooks/useC360Tracker";
import { RemoteHeader } from "../components/remote";
import useWebShellRouteChange from "../hooks/useWebShellRouteChange";
import NoSSR from "./NoSSR";
import { localizationUtils } from "@flights/web-api-utils-universal";
import { trackWithDefaultStage } from "@flights/et-universal";
import { SupportedLocales } from "@bookingcom/lingojs-locales";
import ScreenSizeChangeModal from "../components/elements/ScreenSizeChangeModal";
import SurveyTrackerFlightsUniversal from "../components/remote/SurveyTrackerFlightsUniversal";
import useIsPostBookingRoute from "../hooks/useIsPostBookingRoute";

const InternalTools = React.lazy(
  () => import(/* webpackChunkName: "internal-tools" */ "../components/elements/InternalTools")
);

const App: React.FunctionComponent = function () {
  const { isMobile } = useUserAgent();
  const { isInternal, marketingTrackingVariables, lang, locale } = useGlobalContext();
  const c360Tracker = useC360Tracker();
  const jsErrorReporter = FlightsErrorReporter.getInstance().errorReporter;
  const isPostBooking = useIsPostBookingRoute();

  const isResponsiveFixes = Boolean(!isPostBooking && trackWithDefaultStage("flights_web_cat_responsive_fixes_www", 1));
  const isResponsiveFixesPb = Boolean(
    isPostBooking && trackWithDefaultStage("flights_web_cat_responsive_fixes_pb_www", 1)
  );

  c360Tracker.initC360();

  //send route changes for marketing tracking
  useRouteChangeTracking();

  //send route changes for web performance tracking
  useWebShellRouteChange();

  //pageview is not a bounce ET goals
  usePageviewIsNotABounce();

  //store marketing params in session store
  setMarketingTrackingVariables(marketingTrackingVariables);

  return (
    <BUIProvider
      theme={travellerTheme}
      defaultViewportSize={isMobile ? "small" : "large"}
      defaultRTL={!!(lang && localizationUtils.isRTL(lang))}
      locale={locale as SupportedLocales}
    >
      <ErrorReporter errorDisplayComponent={GenericErrorReport} reporter={jsErrorReporter}>
        <RemoteHeader />
        <SurveyTrackerFlightsUniversal />
        <Layout />
        <Trackers />
        <AriaLive />
        {/* {isWebview && <ScrollToTopOnNavigation />} */}
      </ErrorReporter>
      <NoSSR>
        {isInternal && (
          <Suspense fallback={null}>
            <InternalTools />
          </Suspense>
        )}
      </NoSSR>
      {!isResponsiveFixes && !isResponsiveFixesPb ? <ScreenSizeChangeModal /> : null}
    </BUIProvider>
  );
};

export { App as default };
